import { render, staticRenderFns } from "./Riskmanagementbotview.vue?vue&type=template&id=570dc5a1"
import script from "./Riskmanagementbotview.vue?vue&type=script&lang=js"
export * from "./Riskmanagementbotview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports